import { render } from "./SpinnerView.vue?vue&type=template&id=a6a89eba"
import script from "./SpinnerView.vue?vue&type=script&lang=js"
export * from "./SpinnerView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__